import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { settings } from "../settings";
import { RootState } from "../redux/store";
import { logout, tokenReceived } from "../features/auth/authSlice";
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Organization } from "../redux/slices/organizationsSlice";
import { GRV } from "../constants/values";

const BASE_URL = 'organismos';

const baseQuery = fetchBaseQuery({
    baseUrl: `${settings.url.host}${settings.url.api}`,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
        const accessToken = (getState() as RootState).auth.accessToken;
        if (accessToken) {
            headers.set('authorization', `Bearer ${accessToken}`);
        }
        return headers;
    }
});

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    api,
    extraOptions
) => {
    let result: any = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        const { auth }: any = api.getState();

        const refreshResult = await baseQuery(
            {
                url: '/auth/refresh-token',
                method: 'POST',
                credentials: 'include',
                body: { username: auth?.user?.usuario }
            },
            api,
            extraOptions
        );
        if (refreshResult?.data) {
            api.dispatch(tokenReceived(refreshResult.data));
            result = await baseQuery(args, api, extraOptions);
        } else {
            api.dispatch(logout());
        }
    }
    return result;
};

export const organizationsApi = createApi({
    reducerPath: 'organizationsApi',
    tagTypes: ['Organizations'],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getOrganizations: builder.query({
            query: () => ({
                url: `${BASE_URL}/organizaciones`,
                method: 'GET'
            }),
            transformResponse: (response: { data: { organizaciones: Organization[] } }) => response?.data?.organizaciones || []
        })
    })
})

export const {
    useGetOrganizationsQuery
} = organizationsApi;